<template>
  <div class="login_info_box">
    <div class="login_info_box_item">
      <div>{{ $t('login.user_name') }}</div>
      <div>
        <el-input :placeholder="$t('login.enter_user_name')" v-model="loginForm.loginName" clearable></el-input>
      </div>
    </div>
    <div class="login_info_box_item">
      <div>{{ $t('login.password') }}</div>
      <div>
        <el-input :placeholder="$t('login.enter_password')" v-model="loginForm.password" show-password
                  @keyup.native.enter="login"></el-input>
      </div>
    </div>
    <div class="login_info_box_item">
      <div style="display: flex;">
        <el-input placeholder="验证码" prefix-icon="el-icon-circle-check" v-model="code"
                  @keyup.enter.native="login"></el-input>
        <Sidentify :identifyCode="identifyCode" @click.native="refreshCode"/>
      </div>
    </div>
    <div class="login_info_box_item">
      <b2b-button @click="login">{{ $t('login.login_btn') }}</b2b-button>
    </div>
  </div>
</template>

<script>
import Sidentify from './sidentify.vue'

export default {
  components: {
    Sidentify
  },
  data () {
    return {
      loginForm: {},
      identifyCode: '',
      identifyCodes: '0123456789',
      code: ''
    }
  },
  created () {
    this.makeCode(4)
  },
  methods: {
    async login () {
      if (!this.loginForm.loginName) return this.$message.warning('请输入用户名')
      if (!this.loginForm.password) return this.$message.warning('请输入密码')
      if (!this.code) return this.$message.warning('请输入验证码')
      if (this.code !== this.identifyCode) return this.$message.warning('验证码错误')
      this.loginForm.device = 'from b2b'
      const {data: result} = await this.$http.post('mini/loginByName', this.loginForm)
      if (result.code != 200) return this.$message.error(result.message)
      localStorage.setItem('partnerInfo', JSON.stringify(result.data))
      sessionStorage.removeItem('homeSearchForm')
      this.$router.push('/NewHome')
    },
    refreshCode () {
      this.identifyCode = ''
      this.makeCode(4)
    },
    makeCode (l) {
      let length = this.identifyCodes.length
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[Math.floor(Math.random() * length)]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login_info_box {
  font-size: 14px;

  .login_info_box_item {
    display: grid;
    grid-auto-rows: auto auto;
    grid-row-gap: 10px;
    margin-bottom: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/login/components/LoginByName.vue